module.exports = __webpack_public_path__ + "assets/a95c5e53cbd5d3149f1cc87e3a2a1b2a.mp3";